import { createContext } from "react";

const StoreContext = createContext({
  storeId: null,
  setStoreId: () => {},
});

export default StoreContext;
